import { useMutation } from '@tanstack/react-query';

import { deleteUser } from '../requests';

export const useDeleteUser = () =>
  useMutation({
    mutationFn: deleteUser,
  });
